import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";

const VisitorBookedLayer = () => {
    const [visitorBookedList, setVisitorBookedList] = useState([
        {
          id: 3,
          name: "Saurav",
          phone: "6543210987",
          company: "Ocean Soft",
          email: "saurav@example.com",
          status: "Booked",
        },
    ]);

    useEffect(() => {
        const booked = JSON.parse(localStorage.getItem("visitor_booked_list") || "[]");
        if (booked.length > 0) {
            setVisitorBookedList((prev) => {
                const existingIds = new Set(prev.map((e) => e.id));
                const newOnes = booked.filter((e) => !existingIds.has(e.id));
                return [...prev, ...newOnes];
            });
        }
    }, []);

    return (
        <div className="card h-100 p-0 radius-12 border-0 shadow-sm">
            <div
                className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between"
                style={{
                    background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)",
                }}
            >
                <div className="d-flex align-items-center gap-3">
                    <Link
                        to="/upcoming-expo"
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center w-36-px h-36-px rounded-circle p-0"
                        title="Back to Expos"
                    >
                        <Icon icon="solar:arrow-left-linear" className="text-xl text-dark" />
                    </Link>
                    <h6 className="text-white mb-0 fw-bold">Visitor Booked List</h6>
                </div>
            </div>

            <div className="card-body p-24">
                <div className="table-responsive scroll-sm overflow-x-auto">
                    <table className="table bordered-table sm-table mb-0 text-nowrap" style={{ minWidth: '800px' }}>
                        <thead>
                            <tr style={{ background: "linear-gradient(135deg, #bb0007, #ed1c24)" }}>
                                <th scope="col" style={{ color: "white", width: '70px' }} className="px-16">S.No</th>
                                <th scope="col" style={{ color: "white", width: '200px' }}>Name</th>
                                <th scope="col" style={{ color: "white", width: '150px' }}>Phone</th>
                                <th scope="col" style={{ color: "white", width: '200px' }}>Company</th>
                                <th scope="col" style={{ color: "white", width: '150px' }}>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visitorBookedList.length > 0 ? (
                                visitorBookedList.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="px-16">{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.phone}</td>
                                        <td>{item.company}</td>
                                        <td>
                                            <span className="badge bg-success-focus text-success-main px-12 py-4 radius-4">
                                                {item.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center py-24">No bookings found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default VisitorBookedLayer;
